import styled, { css } from "styled-components";
import { color, font, spacing } from "@runwayhealth/runway-components-react";

const tealFill = "#4F9298";
const railHairline = "rgba(26, 60, 81, 0.08)";
const phoneOnly = "@media (max-width: 479px)";
const wideOnly = "@media (min-width: 480px)";

export const Bar = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.nano};
  box-sizing: border-box;
  width: 100%;
  max-width: 904px;
  min-width: 0;
  margin: 0 auto;
  padding: 2px 16px 12px;
`;

export const Segments = styled.div`
  display: flex;
  gap: ${spacing.quarck};
  min-width: 0;
`;

export const SegmentTrack = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: ${spacing.nano};
  min-width: 0;
`;

export const Rail = styled.div`
  height: 6px;
  border-radius: 3px;
  background: ${railHairline};
  overflow: hidden;
`;

export const Fill = styled.div<{ $ratio: number }>`
  height: 100%;
  width: ${({ $ratio }) => Math.min(Math.max($ratio, 0), 1) * 100}%;
  background: ${tealFill};
  transition: width 400ms ease-in-out;
`;

const nameText = css`
  display: block;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${color.highlight.darkest};
  font-size: ${font.size.xxxs};
`;

export const SegmentName = styled.span<{ $isCurrent: boolean }>`
  ${nameText}
  font-family: ${({ $isCurrent }) =>
    $isCurrent ? font.family.highlight.medium : font.family.highlight.regular};

  ${phoneOnly} {
    display: none;
  }
`;

export const SectionName = styled.span<{ $isShownOnWide: boolean }>`
  ${nameText}
  font-family: ${font.family.highlight.medium};

  ${wideOnly} {
    display: ${({ $isShownOnWide }) => ($isShownOnWide ? "block" : "none")};
  }
`;
